import { DeliveryType } from '@/models'

const DELIVERY_TYPES_MAP: Record<Exclude<DeliveryType, null>, string> = {
  dropByDoor: 'Drop by door',
  toHand: 'Hand it to me',
}

export const getDeliveryTypeName = (type: DeliveryType): string => {
  if (!type) return '-'
  return DELIVERY_TYPES_MAP[type] ?? '-'
}
